export default __webpack_public_path__ + "83815372f0bcbbb4087b40a5b0db632e.svg";